import React, { useState, useEffect } from 'react';
import { Col, Row, Space } from 'antd';
import ModalWrapper from '../../components/ModalWrapper';
import DropdownInput from '../../components/DropdownInput';
import DatePicker from '../../components/DatePicker';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

interface FilterParams {
  status?: 'Active' | 'Passive';
  startDate?: string;
  endDate?: string;
}

interface BlogFilterModalProps {
  onClose: () => void;
  onFilter?: (filters: FilterParams) => void;
  onCancel?: () => void;
  initialValues?: FilterParams;
}

const BlogFilterModal: React.FC<BlogFilterModalProps> = ({ onClose, onFilter, initialValues }) => {
  const [selectedStatus, setSelectedStatus] = useState<string>();
  const [startDate, setStartDate] = useState<Dayjs>();
  const [endDate, setEndDate] = useState<Dayjs>();

  useEffect(() => {
    setSelectedStatus(initialValues?.status);
    setStartDate(initialValues?.startDate ? dayjs(initialValues.startDate) : undefined);
    setEndDate(initialValues?.endDate ? dayjs(initialValues.endDate) : undefined);
  }, [initialValues]);

  const handleSave = () => {
    const filters: FilterParams = {};

    if (selectedStatus) {
      filters.status = selectedStatus as 'Active' | 'Passive';
    }

    if (startDate) {
      filters.startDate = startDate.format('YYYY-MM-DDTHH:mm:ss');
    }

    if (endDate) {
      filters.endDate = endDate.format('YYYY-MM-DDTHH:mm:ss');
    }

    onFilter?.(filters);
    onClose();
  };

  const handleClear = () => {
    setSelectedStatus(undefined);
    setStartDate(undefined);
    setEndDate(undefined);
  };

  const handleCancel = () => {
    setSelectedStatus(initialValues?.status);
    setStartDate(initialValues?.startDate ? dayjs(initialValues.startDate) : undefined);
    setEndDate(initialValues?.endDate ? dayjs(initialValues.endDate) : undefined);
    onClose();
  };

  return (
    <ModalWrapper
      open={true}
      onClose={handleCancel}
      onSave={handleSave}
      onCancel={handleClear}
      title="Filter"
      width={450}
      saveButtonText="Save"
      cancelButtonText="Clear"
    >
      <Space
        direction="vertical"
        size="large"
        style={{ width: '100%' }}
      >
        <DropdownInput
          label="Status"
          options={[
            { label: 'Active', value: 'Active' },
            { label: 'Passive', value: 'Passive' },
          ]}
          value={selectedStatus}
          onChange={setSelectedStatus}
          placeholder="Select status"
          theme="primary"
        />

        <Row gutter={16}>
          <Col span={12}>
            <DatePicker
              label="Start date"
              placeholder="Select"
              value={startDate}
              onChange={setStartDate}
              style={{ width: '100%' }}
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
            />
          </Col>
          <Col span={12}>
            <DatePicker
              label="End date"
              placeholder="Select"
              value={endDate}
              onChange={setEndDate}
              style={{ width: '100%' }}
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
            />
          </Col>
        </Row>
      </Space>
    </ModalWrapper>
  );
};

export default BlogFilterModal;
